import React, { useEffect } from "react";
import Spinner from "../common/Spinner/Spinner";
import { AuthCommandFacade } from "../auth/AuthCommandFacade";
import LogService from "../../utils/logs";
import { getToken } from "../../utils/persist";

// Logs the sign-out while the token is still available, then clears the local session
// and redirects to the IdP's logout endpoint.
const LogoutPage = () => {
  useEffect(() => {
    const logSignout = getToken() ? LogService.logUserSignout() : Promise.resolve();
    Promise.resolve(logSignout)
      .catch((error) => console.error("Sign-out logging failed:", error))
      .then(() => new AuthCommandFacade().logout());
  }, []);

  return (
    <div className="pt-24 flex justify-center" role="status" aria-live="polite" aria-busy="true">
      <span className="sr-only">Signing you out…</span>
      <Spinner />
    </div>
  );
};

export default LogoutPage;
